import { withStyles } from '@wix/wix-vod-shared/dist/src/widget/utils/withStyles';
export { withStyles };
